module.exports = __webpack_public_path__ + "img/ele3.74451384.jpg";